<div class="card mb-3">
    <div class="card-body pb-0">
        <h5 class="card-title">{{ 'utilities_map' | translate }}</h5>
    </div>
    <div id="{{ mapId }}" class="map"></div>
    <div class="card-body">
        <ul class="list-group list-group-flush description-list" data-testid="meter-coordinates">
            <li class="list-group-item">
                <span>{{ 'utilities_latitude' | translate }}</span>
                <span data-testid="meter-latitude">{{ latitude | appnumber: 6 }}</span>
            </li>
            <li class="list-group-item">
                <span>{{ 'utilities_longitude' | translate }}</span>
                <span data-testid="meter-longitude">{{ longitude | appnumber: 6 }}</span>
            </li>
        </ul>
    </div>
</div>
